module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-ExtraBoldItalic.woff2?d47b586181a5bde421420a20e928db26";